<template>
    <div style="width: 100%;display: flex;flex-wrap: wrap;" v-if="item!==null && item.labels!==null && item.labels.length>0">
        <div v-for="label in item.labels" style="margin:2px 7px;display: flex;flex-direction: row;border: 1px solid gray;padding: 4px;">
            <div style="padding:0px 4px;">{{ label.child.name }}</div><div style="border-left:1px solid gray;padding:0px 8px;">{{ label.label.label }} </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        item: { type: Object, default: null }
    },
    data: function () {
        return {

        };
    },
    computed: {

    },
    methods: {

    },
    created: function () {

    },
    destroyed: function () {

    },
    mounted: function () {

    }
}
</script>